// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e274e372","732":"6dd644f3","977":"71eab636"}[chunkId] + ".chunk.js";
};